var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inviteUser"},[_c('div',{staticClass:"wrapper"},[_c('SelectLanguage'),_c('Header',{attrs:{"icon":"check-square"}}),_c('Title',{attrs:{"title":"Invite User"}}),_c('Form',{attrs:{"showForm":_vm.showForm},on:{"tab":_vm.tab}}),_c('FormRegistration',{attrs:{"showFormRegistration":_vm.showFormRegistration}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }